import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import { Body2, Button } from "@fluentui/react-components";
import { AddSquare20Regular } from "@fluentui/react-icons";

import { BaseModal } from "./base-modal.jsx";
import type { SharedModalProps } from "./base-modal.jsx";

/**
 * @warning There is another very similar component used in the Meeting Side Menu. That one is used as "full screen" component. Due to the
 * difference between the two, I've decided to keep them separate.
 * However keep in mind, that any logic or copy change needs to be reflected there as well.
 * @see AddNewBoardInstructions
 */
export const AddNewBoardModal = (props: SharedModalProps) => {
  const handleNavigationToNextStep = useStableCallback(() => {
    props.onClose?.();
    props.onNext?.();
  });

  return (
    <BaseModal
      actionComponent={
        <div className="flex flex-row justify-between">
          <Button
            appearance="transparent"
            className="text-bzd-gray-200"
            onClick={props.onClose}
          >
            Cancel
          </Button>
          <Button onClick={handleNavigationToNextStep}>Next</Button>
        </div>
      }
      title="Add Notes, Whiteboard, Planner, or another item ..."
    >
      <div className="grid w-full grid-cols-6 gap-4 pt-2">
        <div className="col-span-2 gap-2">
          <Body2>
            To add tools or boards to the Table menu, do the following:
          </Body2>

          <ul className="list-outside list-decimal space-y-1 py-4 pl-8">
            <li>
              <Body2>
                Click on the <strong>Next</strong> button.
              </Body2>
            </li>
            <li>
              <Body2>
                To add more or other items, click on the <AddSquare20Regular />{" "}
                button.
              </Body2>
            </li>
          </ul>
        </div>

        <div className="col-span-4">
          <img
            alt="Arrow pointing to the Tab menu of a channel"
            height={1622}
            src="/images/add-table-menu-board.png"
            width={2355}
          />
        </div>
      </div>
    </BaseModal>
  );
};
